export default {"src":"/_next/static/media/twitter.973506be.svg","height":14,"width":16};